export default "__VITE_ASSET__e4fjs0Uy__"